import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import StaticContext from '~/context/common/StaticContext';
import { BrowserCookies } from '~/utilities';
import { getBranchCookieName } from '~/utilities/featureBranch';

export default function useSendFeatureBranchToDataDog() {
  const { kubernetesAppName } = useContext(StaticContext);

  useEffect(() => {
    const featureBranchCookieValue = BrowserCookies.get(
      getBranchCookieName(kubernetesAppName)
    );

    if (featureBranchCookieValue) {
      const featureBranchName = featureBranchCookieValue
        .toLowerCase()
        .match(/reo-[0-9a-z-]*/)?.[0];

      if (featureBranchName) {
        datadogRum.setGlobalContextProperty('featureBranch', featureBranchName);
      }
    }
  }, [kubernetesAppName]);
}
